import React, { Component, Fragment } from "react";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import { defineMessages } from "react-intl";
import { showRoutingAndAccountNumbers, showAccountType, trimBankInfo } from "../utils";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import accountTypeOptions from "../accountTypeOptions";
import CheckboxFormGroup from "assets/scripts/components/common/form/CheckboxFormGroup/CheckboxFormGroup";
import check from "../../../../../../media/images/blank-check.png";
import styles from "./BankInfoFields.module.less";
const messages = defineMessages({
    bankInfoIdLabel: {
        id: "forms.payNow.bankInfoId.label",
        defaultMessage: "Select Account"
    },
    routingNumberLabel: {
        id: "forms.payNow.routingNumber.label",
        defaultMessage: "Routing Number"
    },
    routingNumberHelp: {
        id: "forms.payNow.routingNumber.help",
        defaultMessage: "Example: 123456789"
    },
    accountNumberLabel: {
        id: "forms.payNow.accountNumber.label",
        defaultMessage: "Account Number"
    },
    accountNumberHelp: {
        id: "forms.payNow.accountNumber.help",
        defaultMessage: "Example: 12345678"
    },
    accountTypeLabel: {
        id: "forms.payNow.accountType.label",
        defaultMessage: "Account Type"
    },
    saveBankInfoLabel: {
        id: "forms.payNow.saveBankInfo.label",
        defaultMessage: "Save bank account for future use?"
    },
    bankInfoNameLabel: {
        id: "forms.payNow.bankInfoName.label",
        defaultMessage: "Bank Name (optional)"
    },
    newBankAccount: {
        id: "forms.payNow.bankInfoId.options.newBankAccount",
        defaultMessage: "Use a new bank account"
    }
});
export default class BankInfoFields extends Component {
    constructor() {
        super(...arguments);
        this._handleBankInfoIdChange = (bankInfoId) => this.props.onChange({ bankInfoId });
        this._handleRoutingNumberChange = (routingNumber) => this.props.onChange({ routingNumber });
        this._handleAccountNumberChange = (accountNumber) => this.props.onChange({ accountNumber });
        this._handleAccountTypeChange = (accountType) => this.props.onChange({ accountType });
        this._handleSaveBankInfoChange = (saveBankInfo) => this.props.onChange({ saveBankInfo });
        this._handleBankInfoNameChange = (bankInfoName) => this.props.onChange({ bankInfoName });
        this._handleBlur = () => {
            this.props.onChange(trimBankInfo(this.props.value));
        };
    }
    render() {
        const { props } = this;
        const { value, errors, backendErrors, disableBankSave } = props;
        return (<Fragment>
				{process.env.FEATURE_SAVE_BANK_INFO && props.profile.bankAccounts.length > 0 && (<SelectFormGroup name="bankInfoId" label={messages.bankInfoIdLabel} value={value.bankInfoId} onChange={this._handleBankInfoIdChange} backendError={backendErrors.bankInfo} required options={[
            ...props.profile.bankAccounts.map(bankInfo => ({
                value: bankInfo.id.toString(),
                label: bankInfo.name
            })),
            {
                value: "-1",
                label: messages.newBankAccount
            }
        ]}/>)}

				{showAccountType(value) && (<SelectFormGroup name="accountType" label={messages.accountTypeLabel} value={value.accountType} onChange={this._handleAccountTypeChange} error={errors.accountType} backendError={backendErrors.accountType} required options={[
            {
                value: "",
                label: ""
            },
            ...Object.entries(accountTypeOptions).map(([accountType, label]) => ({
                value: accountType,
                label
            }))
        ]}/>)}

				{showRoutingAndAccountNumbers(value) && (<Fragment>
						<TextFormGroup name="routingNumber" type="number" className="form-group-paymentInfo-routingNumber" label={messages.routingNumberLabel} help={messages.routingNumberHelp} value={value.routingNumber} onChange={this._handleRoutingNumberChange} error={errors.routingNumber} backendError={backendErrors.routingNumber} required inputProps={{ onBlur: this._handleBlur }}/>
						<TextFormGroup name="accountNumber" type="number" className="form-group-paymentInfo-accountNumber" label={messages.accountNumberLabel} help={messages.accountNumberHelp} value={value.accountNumber} onChange={this._handleAccountNumberChange} error={errors.accountNumber} backendError={backendErrors.accountNumber} required inputProps={{ onBlur: this._handleBlur }}/>
					</Fragment>)}

				{process.env.CLIENT === undefined && showRoutingAndAccountNumbers(value) && value.accountType === "c" && (<img className={styles.check} src={check}/>)}

				{process.env.FEATURE_SAVE_BANK_INFO && value.bankInfoId === "-1" && !disableBankSave && (<Fragment>
						<CheckboxFormGroup name="saveBankInfo" label={messages.saveBankInfoLabel} value={value.saveBankInfo} onChange={this._handleSaveBankInfoChange}/>
						{value.saveBankInfo && (<TextFormGroup name="bankInfoName" error={errors.name} label={messages.bankInfoNameLabel} value={value.bankInfoName} onChange={this._handleBankInfoNameChange}/>)}
					</Fragment>)}

			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/PayNowForm/BankInfoFields/BankInfoFields.tsx